import { ParsedUrlQuery } from 'querystring';
import { IFacet, IFacetValue, IFilter } from '~/lib/data-contract';

/**
 * Updates data from product filter module to use the router query as source of truth
 * So that even if the data is still being fetched for new products the applied facets will be up-to-date
 */
export const applyRouteFacetQuery = (moduleFilter: IFilter, query: ParsedUrlQuery): IFilter => {
	const facets: IFacet[] = [];
	moduleFilter.facets.forEach((facet) => {
		const queryValue = query[facet.id];
		const values: IFacetValue[] = [];
		facet.values.forEach((facetValue) => {
			values.push({
				...facetValue,
				selected: typeof queryValue === 'string' ? facetValue.id === queryValue : Array.isArray(queryValue) ? queryValue.includes(facetValue.id) : false,
			});
		});
		facets.push({ ...facet, values });
	});
	return { ...moduleFilter, facets };
};
